import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactModal from 'react-modal'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import ContentJournalResults from './ContentResults/ContentJournalResults'

import ContentPollResults from './ContentResults/ContentPollResults'
import ContentSurveyResults from './ContentResults/ContentSurveyResults'
import { ANALYTICS_EVENTS } from '../../analytics/events'
import useTrackedSurface from '../../analytics/useTrackedSurface'

const ShowContentResultsModal = memo(({ showRun, closeRun, content, setContent, setRefresh, deleteContent, hideControlDetails = false, classId = null, analyticsScope = null }) => {
    const { t, locale } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.DASHBOARD_CONTENT_RESULTS_VIEWED, {
        active: showRun,
        contentId: content?.id,
        content: content?.title,
    })

    useEffect(() => {
        if (showRun) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [showRun])

    const mapType = {
        poll: <ContentPollResults content={content} setContent={setContent} setRefresh={setRefresh} deleteContent={deleteContent} hideControlDetails={hideControlDetails} />,
        question: <ContentPollResults content={content} setContent={setContent} setRefresh={setRefresh} deleteContent={deleteContent} hideControlDetails={hideControlDetails} />,
        survey: (
            <ContentSurveyResults
                content={content}
                setContent={setContent}
                setRefresh={setRefresh}
                deleteContent={deleteContent}
                hideControlDetails={hideControlDetails}
                classId={classId}
                analyticsScope={analyticsScope}
            />
        ),
        journal: <ContentJournalResults content={content} setContent={setContent} setRefresh={setRefresh} deleteContent={deleteContent} hideControlDetails={hideControlDetails} />,
    }

    return (
        <ReactModal
            transparent
            closeTimeoutMS={600}
            isOpen={showRun}
            onAfterOpen={() => {}}
            onRequestClose={closeRun}
            // Drops the sidebar under this overlay while open (see SideBar.css).
            htmlOpenClassName="content-results-open"
            style={{
                overlay: {
                    zIndex: 11,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 1000,
                    minWidth: 1000,
                    margin: 'auto',
                    // marginTop: '2%',
                    backgroundColor: 'transparent',
                    border: 'none',
                    margin: 'auto',
                    boxShadow: 'none',
                    overflow: 'hidden',
                },
            }}
        >
            <div>
                <div className="w-full justify-center flex">
                    <button
                        id="close-content-results-modal-button"
                        className="hover:bg-darkenPurple pointer absolute top-[10px] flex bg-deepPurple rounded-full w-[60px] h-[60px] justify-center items-center z-10"
                        onClick={closeRun}
                    >
                        <CloseModalIcon />
                    </button>
                </div>
                <div className="bg-white rounded-xl mt-10 mr-6 h-full ">{mapType[content?.type]}</div>
            </div>
        </ReactModal>
    )
})

export default ShowContentResultsModal
